import CategoryPageSection from 'components/CategoryPage/CategoryPageSection/CategoryPageSection';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import fetchAndSetRecentlyViewedProductsOperation from 'store/category/operation/fetchAndSetRecentlyViewedProductsOperation';
import getRecentlyViewedProducts from 'store/category/selector/getRecentlyViewedProducts';
// import recentlyViewedProducts from 'mockups/recentlyViewed';
import Carousel from '../Carousel/Carousel';
import styles from './RecentlyViewed.module.scss';
import RecentlyViewedProduct from './RecentlyViewedProduct/RecentlyViewedProduct';

const RecentlyViewed = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const recentlyViewedProducts = useSelector(getRecentlyViewedProducts);

  useEffect(() => {
    dispatch(fetchAndSetRecentlyViewedProductsOperation());
  }, []);

  if (!recentlyViewedProducts || recentlyViewedProducts.length === 0) {
    return null;
  }

  return (
    <section className={styles.recentlyViewed}>
      <CategoryPageSection>{t('txt_recently_viewed_items')}</CategoryPageSection>
      <Carousel className={styles.carousel}>
        {recentlyViewedProducts.map((product) => (
          <RecentlyViewedProduct key={`item_${product.publicDesignId}`} product={product} />
        ))}
      </Carousel>
    </section>
  );
};

export default RecentlyViewed;
